import script from "./PageDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageDocument.vue?vue&type=script&setup=true&lang=ts"

import "./PageDocument.vue?vue&type=style&index=0&id=5cf1c525&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf1c525"]])

export default __exports__